import { styled } from 'styled-components';
import { ReactNode } from 'react';

import { Assets, Box, Container, Flex, Headings, theme, useIsDeviceSize } from '@foradevelopment/fora-ui';

import { EmployerDetails } from './EmployerDetails';
import { ChangeEmployerDropdown } from './ChangeEmployerDropdown';
import { useAppSelector } from '../../redux/hooks';

export const CompanyDetailsCard = () => {
  const { isDesktop } = useIsDeviceSize();

  const selectedPartnerNumber = useAppSelector(state => state.auth.user?.selectedPartnerNumberOrganization);
  const { employerInfo, administrableEmployers } = useAppSelector(state => state.employer);

  const multiAdmin = administrableEmployers.length > 1;

  const variant =
    selectedPartnerNumber && multiAdmin
      ? 'dropdown-and-employer'
      : selectedPartnerNumber && !multiAdmin
        ? 'employer-only'
        : 'dropdown-only';

  // Employer details only
  if (variant === 'employer-only') {
    return (
      <CompanyDetailsCardWrapper>
        <Flex alignItems="flex-start">
          <Assets.BindersIcon color="white" width={22} marginRight={10} />
          <Headings.H5 marginBottom={10} color="white">
            {employerInfo.organizationName}
          </Headings.H5>
        </Flex>
        <EmployerDetails {...employerInfo} layout={isDesktop ? 'row' : 'column'} />
      </CompanyDetailsCardWrapper>
    );
  }

  // Dropdown and employer details
  if (variant === 'dropdown-and-employer') {
    return (
      <CompanyDetailsCardWrapper>
        <Flex flexDirection={['column', 'column', 'row']} columnGap={40} rowGap={20} alignItems="center">
          <ChangeEmployerDropdown currentPartnerNumber={selectedPartnerNumber} />
          <EmployerDetails {...employerInfo} layout="column" />
        </Flex>
      </CompanyDetailsCardWrapper>
    );
  }

  // Dropdown only
  return (
    <Container width={['100%', '100%', '50%']}>
      <CompanyDetailsCardWrapper>
        <ChangeEmployerDropdown currentPartnerNumber={selectedPartnerNumber} />
      </CompanyDetailsCardWrapper>
    </Container>
  );
};

const CompanyDetailsCardWrapper = ({ children }: { children: ReactNode }) => (
  <Box backgroundColor="darkBlue" style={{ padding: '20px 40px' }} position="relative" borderRadius="4px">
    <SummaryCardCorner />
    {children}
  </Box>
);

const SummaryCardCorner = styled.span`
  position: absolute;
  width: 0rem;
  height: 0rem;
  border-bottom: 50px solid ${theme.colors.shadowDarkBlue};
  border-left: 10px solid transparent;
  left: -0.625rem;
  top: 0.0925rem;
  /* border-top-right-radius: 4px; Edge doesn't like it */
  @media screen and (min-width: ${theme.breakpoint.md}px) {
    border-bottom: 50px solid ${theme.colors.shadowDarkBlue};
    border-left: 20px solid transparent;
    left: -1.25rem;
  }
  @media screen and (min-width: ${theme.breakpoint.lg}px) {
    left: -1.875rem;
    border-bottom: 50px solid ${theme.colors.shadowDarkBlue};
    border-left: 30px solid transparent;
  }
`;
